import {getField, updateField} from "vuex-map-fields";

/**
 * @module Stats
 */
export default {
  namespaced: true,
  state: {
    formData: [],
    trackData: [],
    statsData: {
      auctionCount: 0,
      commentList: 0,
      mappingCount: 0,
      ratingAverage: 0,
      userCount: 0,
      activeUsers:0,
      expiredSoonUsers: 0,
      expiredUsers:0
    }

  },
  getters: {getField},
  mutations: {
    updateField,
    settingData: function (state, data) {
      eval("state." + data.name + "=  data.content");
    },
    statsDataSet: function (state, data) {
      // state.statsData.auctionCount = data.auctionCount;
      // state.statsData.commentList = data.commentList;
      // state.statsData.mappingCount = data.mappingCount;
      // state.statsData.ratingAverage = data.ratingAverage;
      // state.statsData.userCount = data.userCount;
      // state.statsData.freeUsers = data.freeUsers;
      state.statsData.activeUsers = data.activeUsers;
      state.statsData.expiredSoonUsers = data.expiredSoonUsers;
      state.statsData.expiredUsers = data.expiredUsers;
    }
  },
  actions: {

    trackList: function (state) {
      axios.get('/api/v1/coach/trackList')
        .then(response => {
          state.commit('settingData', {
            content: response.data, name: 'trackData'
          });
        });
    },

    getStats: function (state) {
      axios.post('/api/v1/stats', {
        startDate: state.state.formData.startDate,
        endDate: state.state.formData.endDate,
      })
        .then(function (response) {
          state.commit('statsDataSet', response.data);
        })
        .catch(function (error) {
          console.log(error)
        })
    },

  }
}